/* eslint-disable */
const splitChars = () => {
	const splitChars = document.querySelectorAll('.block-stat > h2');
	splitChars.forEach((item) => {
		const text = item.textContent;
		const chars = text.split('');
		item.innerHTML = chars
			.map(
				(char, index) =>
					`<span class="stat-char" style="animation-delay: ${
						0.06 * index + 0.8
					}s">${char}</span>`
			)
			.join('');
	});
};

splitChars();
/* eslint-enable */
